import BoostPassiveAbstractStore from "./BoostPassiveAbstractStore";

export default class BoostPortionStore extends BoostPassiveAbstractStore {}